<nz-spin nzSize="default" [nzSpinning]="spinning" [nzTip]="tip ?? ''">
  <ng-content></ng-content>
</nz-spin>
